import React, { useState, useEffect, useRef, useImperativeHandle } from 'react'
import moment from 'moment'
import { oktmo2name, code2region, industry_icon } from './Utils'
import { Button } from 'primereact/button'
import { Panel } from 'primereact/panel'
import { Slider } from 'primereact/slider'
import { Checkbox } from 'primereact/checkbox'
import { MultiStateCheckbox } from 'primereact/multistatecheckbox'
import { InputNumber } from 'primereact/inputnumber'
import { ToggleButton } from 'primereact/togglebutton'
import { RadioButton } from 'primereact/radiobutton'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { InputTextarea } from 'primereact/inputtextarea'

const MapFilters = React.forwardRef((props, ref) => {
	
	const { ENV, DS, resetMapView } = props
	
	// time controller
	const [startDate, setStartDate] = useState(moment())
	const [currentMomentOffset, setCurrentMomentOffset] = useState(0)
	const [maxMoment, setMaxMoment] = useState(0)
	const [currentMoment, setCurrentMoment] = useState(moment())
	useEffect(() => {
		const d1 = moment(DS.filters.date1).hours(9).minutes(0).seconds(0).milliseconds(0)
		const d2 = (DS.filters.date2 ? moment(DS.filters.date2) : moment()).hours(9).minutes(0).seconds(0).milliseconds(0).add(1, 'd')
		const _dur = moment.duration(d2.diff(d1)).as('hours')
		setStartDate(d1)
		setCurrentMomentOffset(_dur)
		setMaxMoment(_dur)
	}, [DS.filters.date1, DS.filters.date2])
	useEffect(() => {
		const _currentMoment = startDate.clone().add(currentMomentOffset, 'h')
		setCurrentMoment(_currentMoment)
	}, [currentMomentOffset, startDate, maxMoment])
	
	
	// show resolved
	const [showResolvedEvents, setShowResolvedEvents] = useState(true)
	
	const [showTypesOfEvents, setShowTypesOfEvents] = useState({all: true})
	const setTypesOfEvents = (o) => {
		if (Object.keys(o)[0] === 'all') setShowTypesOfEvents(o)
		else setShowTypesOfEvents(Object.assign({}, showTypesOfEvents, {all: false}, o))
	}
	
	// fire controller
	const maxFireMomentOffset = 24
	const fireMomentWindowSize = 12
	const [fireMomentOffset, setFireMomentOffset] = useState(maxFireMomentOffset - 3)
	useEffect(() => {
		if (DS.data.showFire) {
			const _right = (['Оперативный'].includes(DS.filters.period) ? DS.data.loaded : currentMoment).clone().add(fireMomentOffset - maxFireMomentOffset, 'hours')
			const _left = _right.clone().subtract(fireMomentWindowSize, 'hours')
			console.log('reload fire', _left, '-', _right)
			DS.loadFire(_left, _right)
		}
	}, [fireMomentOffset, currentMoment, DS.data.showFire, DS.data.loaded])
	
	// weather controller
	const maxWeatherMomentOffset = 12
	const weatherMomentWindowSize = 8
	const weatherMomentShift = 2
	const [weatherMomentOffset, setWeatherMomentOffset] = useState(maxWeatherMomentOffset - weatherMomentShift)
	useEffect(() => {
		if (DS.data.showWeatherArchive) {
			const _right = (['Оперативный'].includes(DS.filters.period) ? DS.data.loaded : currentMoment).clone().add(weatherMomentOffset - maxWeatherMomentOffset + weatherMomentShift, 'hours')
			const _left = _right.clone().subtract(weatherMomentWindowSize, 'hours')
			//console.log('reload weather', _left, '-', _right)
			DS.loadWeatherArchive(_left, _right)
		}
	}, [weatherMomentOffset, currentMoment, DS.data.showWeatherArchive, DS.data.loaded])
	
	// quake controller
	const defaultQuakeOffset = 24 * 1
	const [quakeMomentOffset, setQuakeMomentOffset] = useState(DS.data.maxQuakeMomentOffset - defaultQuakeOffset)
	useEffect(() => {
		if (['Оперативный', 'Ежедневный'].includes(DS.filters.period)) {
			DS.setters.setShowAllQuakes(false)
		} else if (['Еженедельный', 'За период'].includes(DS.filters.period)) {
			DS.setters.setShowAllQuakes(true)
		}
	}, [DS.filters.period])
	useEffect(() => {
		if (DS.data.showQuakes) {
			const _date1 = DS.data.showAllQuakes ? moment(DS.filters.date1).hours(9).minutes(0).seconds(0).milliseconds(0) :
				(['Оперативный'].includes(DS.filters.period) ? DS.data.loaded : currentMoment).clone().add(quakeMomentOffset - DS.data.maxQuakeMomentOffset, 'hours')
			const _date2 = ['Оперативный'].includes(DS.filters.period) ? DS.data.loaded : currentMoment
			DS.setters.setFQuakes(DS.data.quakes.filter(e => e.ds.isBetween(_date1, _date2, undefined, '[]')))
		}
	}, [quakeMomentOffset, currentMoment, DS.data.showQuakes, DS.data.showAllQuakes, DS.data.loaded])
	
	
	
	// functions
	const isRelativlyNotResolved = (event) => event.de === null ? true : event.de.isAfter(currentMoment)
	
	//exposed functions
	useImperativeHandle(ref, () => ({
		isRelativlyNotResolved(event) {
			return isRelativlyNotResolved(event)
		},
	}))
	
	
	
	// events filter
	// TODO: showTypesOfEvents
	useEffect(() => {
		const _e = DS.data.events
			.filter(e => showResolvedEvents || !e.de || isRelativlyNotResolved(e))
			.filter(e => e.ds.isBefore(currentMoment))
			.filter(e => showTypesOfEvents.all || e._m === 't' && showTypesOfEvents.mass || e._e === 't' && showTypesOfEvents.emergency || showTypesOfEvents[industry_icon[e.industry]] || e.is_nuclear === '1' && showTypesOfEvents.nuke)
		DS.setters.setFEvents(_e)
	}, [DS.data.events, showResolvedEvents, showTypesOfEvents, currentMoment])
	
	const [showEvents, setShowEvents] = useState(true)
	const eventsFilter = <Panel className="controller" header={<span className="mr-2">{'Аварии'}</span>} toggleable collapsed={!showEvents} onCollapse={() => setShowEvents(false)} onExpand={() => setShowEvents(true)} >
		<div className="controller-time p-2">
			<div className="text-center mb-2 font-bold">
				{['Оперативный'].includes(DS.filters.period) ? DS.data.loaded.format('DD-MM-YYYY HH:mm') : currentMoment.format('DD-MM-YYYY HH:mm')}
			</div>
			<Slider value={currentMomentOffset} min={0} max={maxMoment} step={3} onChange={(e) => setCurrentMomentOffset(e.value)} onMouseDown={e => e.target.focus()} disabled={['Оперативный', 'Ежедневный'].includes(DS.filters.period)}/>
		</div>
		<div className="m-3">
			<div className="flex align-items-center">
				<Checkbox inputId="showResolvedEvents" onChange={(e) => setShowResolvedEvents(e.checked)} checked={showResolvedEvents} />
				<label htmlFor="showResolvedEvents" className="ml-2">{'Завершенные аварии'}</label>
			</div>
		</div>
		<div className="m-3">
			<div className="flex align-items-center my-1">
				<Checkbox inputId="showAllEvents" onChange={(e) => setTypesOfEvents({all: e.checked})} checked={showTypesOfEvents.all} />
				<label htmlFor="showAllEvents" className="ml-2">{'Все'}</label>
			</div>
			<div className="flex align-items-center my-1">
				<ToggleButton className="industry red" onChange={(e) => setTypesOfEvents({emergency: e.value})} checked={showTypesOfEvents.emergency} pt={{input: {id: 'showAccidentEvents'}}}
					onLabel="" offLabel="" offIcon={() => <img className="icon" src={`${ENV.imgUrl}emergency-off.svg`} />} onIcon={() => <img className="icon" src={`${ENV.imgUrl}emergency-on.svg`} />}
				/>
				<label htmlFor="showAccidentEvents" className="ml-2">{'ЧС / НС'}</label>
			</div>
			<div className="flex align-items-center my-1">
				<ToggleButton className="industry red" onChange={(e) => setTypesOfEvents({mass: e.value})} checked={showTypesOfEvents.mass} pt={{input: {id: 'showMassEvents'}}}
					onLabel="" offLabel="" offIcon={() => <img className="icon" src={`${ENV.imgUrl}mass-off.svg`} />} onIcon={() => <img className="icon" src={`${ENV.imgUrl}mass-on.svg`} />}
				/>
				<label htmlFor="showMassEvents" className="ml-2">{'Массовые отключения'}</label>
			</div>
			<div className="flex align-items-center my-1">
				<ToggleButton className="industry" onChange={(e) => setTypesOfEvents({electric: e.value})} checked={showTypesOfEvents.electric} pt={{input: {id: 'showElectricEvents'}}}
					onLabel="" offLabel="" offIcon={() => <img className="icon" src={`${ENV.imgUrl}electric-off.svg`} />} onIcon={() => <img className="icon" src={`${ENV.imgUrl}electric-on.svg`} />}
				/>
				<label htmlFor="showElectricEvents" className="ml-2">{'Электроэнергетика'}</label>
			</div>
			<div className="flex align-items-center my-1">
				<ToggleButton className="industry" onChange={(e) => setTypesOfEvents({nuke: e.value})} checked={showTypesOfEvents.nuke} pt={{input: {id: 'showNukeEvents'}}}
					onLabel="" offLabel="" offIcon={() => <img className="icon" src={`${ENV.imgUrl}atom-off.svg`} />} onIcon={() => <img className="icon" src={`${ENV.imgUrl}atom-on.svg`} />}
				/>
				<label htmlFor="showNukeEvents" className="ml-2">{'Атом'}</label>
			</div>
			<div className="flex align-items-center my-1">
				<ToggleButton className="industry" onChange={(e) => setTypesOfEvents({heat: e.value})} checked={showTypesOfEvents.heat} pt={{input: {id: 'showHeatEvents'}}}
					onLabel="" offLabel="" offIcon={() => <img className="icon" src={`${ENV.imgUrl}heat-off.svg`} />} onIcon={() => <img className="icon" src={`${ENV.imgUrl}heat-on.svg`} />}
				/>
				<label htmlFor="showHeatEvents" className="ml-2">{'Тепло'}</label>
			</div>
			<div className="flex align-items-center my-1">
				<ToggleButton className="industry" onChange={(e) => setTypesOfEvents({oil: e.value})} checked={showTypesOfEvents.oil} pt={{input: {id: 'showOilEvents'}}}
					onLabel="" offLabel="" offIcon={() => <img className="icon" src={`${ENV.imgUrl}oil-off.svg`} />} onIcon={() => <img className="icon" src={`${ENV.imgUrl}oil-on.svg`} />}
				/>
				<label htmlFor="showOilEvents" className="ml-2">{'Нефть'}</label>
			</div>
			<div className="flex align-items-center my-1">
				<ToggleButton className="industry" onChange={(e) => setTypesOfEvents({gas: e.value})} checked={showTypesOfEvents.gas} pt={{input: {id: 'showGasEvents'}}}
					onLabel="" offLabel="" offIcon={() => <img className="icon" src={`${ENV.imgUrl}gas-off.svg`} />} onIcon={() => <img className="icon" src={`${ENV.imgUrl}gas-on.svg`} />}
				/>
				<label htmlFor="showGasEvents" className="ml-2">{'Газ'}</label>
			</div>
			<div className="flex align-items-center my-1">
				<ToggleButton className="industry" onChange={(e) => setTypesOfEvents({coal: e.value})} checked={showTypesOfEvents.coal} pt={{input: {id: 'showCoalEvents'}}}
					onLabel="" offLabel="" offIcon={() => <img className="icon" src={`${ENV.imgUrl}coal-off.svg`} />} onIcon={() => <img className="icon" src={`${ENV.imgUrl}coal-on.svg`} />}
				/>
				<label htmlFor="showCoalEvents" className="ml-2">{'Уголь'}</label>
			</div>
		</div>
	</Panel>
	
	const [showFire, setShowFire] = useState(false)
	const fireFilter = <Panel className="controller mt-3" header={<span className="mr-2">{'Пожары'}</span>} toggleable collapsed={!showFire} onCollapse={() => setShowFire(false)} onExpand={() => setShowFire(true)} >
		<div className="m-3">
			<div className="flex align-items-center">
				<Checkbox inputId="showFireRegCl" onChange={(e) => DS.setters.setShowFireRegCl(e.checked)} checked={DS.data.showFireRegCl} />
				<label htmlFor="showFireRegCl" className="ml-2">{'Расчёт пожароопасности'}</label>
			</div>
		</div>
		<div className="controller-time p-2">
			<div className="text-center mb-2 font-bold">
				{(['Оперативный'].includes(DS.filters.period) ? DS.data.loaded : currentMoment).clone().add(fireMomentOffset - maxFireMomentOffset, 'hours').format('DD-MM-YYYY HH:mm') + 
					(fireMomentOffset === maxFireMomentOffset ? ' (+00:00)' : fireMomentOffset === 0 ? ` (-${maxFireMomentOffset}:00)` : moment('2000-01-01 00:00').add(maxFireMomentOffset - fireMomentOffset, 'hours').format(' (-HH:mm)'))
				}
			</div>
			<Slider value={fireMomentOffset} min={0} max={maxFireMomentOffset} step={1} onChange={(e) => setFireMomentOffset(e.value)} onMouseDown={e => e.target.focus()} />
		</div>
		<div className="m-3">
			<div className="flex align-items-center">
				<Checkbox inputId="showAllFires" onChange={(e) => DS.setters.setShowFire(e.checked)} checked={DS.data.showFire} />
				<label htmlFor="showAllFires" className="ml-2">{'Отображать на карте'}</label>
			</div>
		</div>
		<div className="m-3">
			<div className="flex align-items-center">
				<Checkbox inputId="showActuality" onChange={(e) => DS.setters.setShowFireActuality(e.checked)} checked={DS.data.showFireActuality} disabled={!DS.data.showFire}/>
				<label htmlFor="showActuality" className={'ml-2' + (DS.data.showFire ? '' : ' op5')}>{'Обозначать актуальность данных'}</label>
			</div>
		</div>
	</Panel>
	
	const [showWeather, setShowWeather] = useState(false)
	const weatherFilter = <Panel className="controller mt-3 weather-arch" header={<span className="mr-2">{'Архив фактической погоды'}</span>} toggleable collapsed={!showWeather} onCollapse={() => setShowWeather(false)} onExpand={() => setShowWeather(true)}>
		<div className="m-3">
			<div className="flex align-items-center">
				<Checkbox inputId="showWeather" onChange={(e) => DS.setters.setShowWeatherArchive(e.checked)} checked={DS.data.showWeatherArchive} />
				<label htmlFor="showWeather" className="ml-2">{'Показывать на карте'}</label>
			</div>
		</div>
		<div className="controller-time p-2">
			<div className="text-center mb-2 font-bold">
				{(['Оперативный'].includes(DS.filters.period) ? DS.data.loaded : currentMoment).clone().add(weatherMomentOffset - maxWeatherMomentOffset, 'hours').format('DD-MM-YYYY HH:mm') + 
					(weatherMomentOffset === maxWeatherMomentOffset ? ' (+00:00)' : weatherMomentOffset === 0 ? ` (-${maxWeatherMomentOffset}:00)` : moment('2000-01-01 00:00').add(maxWeatherMomentOffset - weatherMomentOffset, 'hours').format(' (-HH:mm)'))
				}
			</div>
			<Slider value={weatherMomentOffset} min={0} max={maxWeatherMomentOffset} step={1} onChange={(e) => setWeatherMomentOffset(e.value)} onMouseDown={e => e.target.focus()} />
		</div>
		<div className="m-3">
			<div className="flex align-items-center">
				<Checkbox inputId="showMeteoDetails" onChange={(e) => DS.setters.setShowMeteoDetails(e.checked)} checked={DS.data.showMeteoDetails} />
				<label htmlFor="showMeteoDetails" className="ml-2">Показывать данные метеостанций</label>
			</div>
		</div>
		<div className="controller-ice p-3 m-3">
			<div className="flex align-items-center mb-2">
				<Checkbox inputId="showIcingZones" onChange={(e) => DS.setters.setShowIcingZones(e.checked)} checked={DS.data.showIcingZones} />
				<label htmlFor="showIcingZones" className="ml-2">Возможно обледенение</label>
			</div>
			<div className="text mb-2">{`Влажность выше `}<span className="font-bold">{DS.data.icingHum}</span>{` %`}</div>
			<Slider value={DS.data.icingHum} min={70} max={100} onChange={(e) => DS.setters.setIcingHum(e.value)} />
			<div className="text mb-2 mt-4">{`Ветер до `}<span className="font-bold">{DS.data.icingWind}</span>{` м/с`}</div>
			<Slider value={DS.data.icingWind} min={0} max={10} onChange={(e) => DS.setters.setIcingWind(e.value)} />
			<div className="text mb-2 mt-4">{`Температура от `}<span className="font-bold">{DS.data.icingTemp[0] > 0 ? '+' : ''}{DS.data.icingTemp[0]}</span>{` до `}<span className="font-bold">{DS.data.icingTemp[1] > 0 ? '+' : ''}{DS.data.icingTemp[1]}</span>{` °C`}</div>
			<Slider value={DS.data.icingTemp} min={-15} max={5} onChange={(e) => DS.setters.setIcingTemp(e.value)} range />
		</div>
		<div className="controller-wind p-3 m-3">
			<div className="flex align-items-center mb-2">
				<Checkbox inputId="showWindZones" onChange={(e) => DS.setters.setShowWindZones(e.checked)} checked={DS.data.showWindZones} />
				<label htmlFor="showWindZones" className="ml-2">Сильный ветер</label>
			</div>
			<div className="text mb-2">{`Ветер сильнее `}<span className="font-bold">{DS.data.windWind}</span>{` м/с`}</div>
			<Slider value={DS.data.windWind} min={5} max={30} onChange={(e) => DS.setters.setWindWind(e.value)} />
		</div>
		<div className="controller-cold p-3 m-3">
			<div className="flex align-items-center mb-2">
				<Checkbox inputId="showColdTempZones" onChange={(e) => DS.setters.setShowColdTempZones(e.checked)} checked={DS.data.showColdTempZones} />
				<label htmlFor="showColdTempZones" className="ml-2">Аномальный холод</label>
			</div>
			<div className="mb-2">{`Температура менее `}<span className="font-bold">{DS.data.coldTemp}</span>{` °C`}</div>
			<Slider value={DS.data.coldTemp} min={-50} max={-25} onChange={(e) => DS.setters.setColdTemp(e.value)} />
		</div>
		<div className="controller-hot p-3 m-3">
			<div className="flex align-items-center mb-2">
				<Checkbox inputId="showHotTempZones" onChange={(e) => DS.setters.setShowHotTempZones(e.checked)} checked={DS.data.showHotTempZones} />
				<label htmlFor="showHotTempZones" className="ml-2">Аномальная жара</label>
			</div>
			<div className="text mb-2">{`Температура выше `}<span className="font-bold">{DS.data.hotTemp}</span>{` °C`}</div>
			<Slider value={DS.data.hotTemp} min={5} max={40} onChange={(e) => DS.setters.setHotTemp(e.value)} />
		</div>
	</Panel>
	
	const [showQuake, setShowQuake] = useState(false)
	const quakeFilter = <Panel className="controller mt-3" header={<span className="mr-2">{'Землетрясения'}</span>} toggleable collapsed={!showQuake} onCollapse={() => setShowQuake(false)} onExpand={() => setShowQuake(true)} >
		<div className="mx-3 mt-3">
			<div className="flex align-items-center">
				<Checkbox inputId="showQuakes" onChange={(e) => DS.setters.setShowQuakes(e.checked)} checked={DS.data.showQuakes} />
				<label htmlFor="showQuakes" className="ml-2">{'Отображать на карте'}</label>
			</div>
		</div>
		<div className="mx-3 mt-3">
			<div className="flex align-items-center">
				<RadioButton inputId="showAllQuakes" name="quakesMode" checked={DS.data.showAllQuakes} onChange={() => DS.setters.setShowAllQuakes(true)} disabled={['Оперативный'].includes(DS.filters.period)} />
				<label htmlFor="showAllQuakes" className={'ml-2' + (['Оперативный'].includes(DS.filters.period) ? ' op5' : '')}>
					{['Оперативный'].includes(DS.filters.period) ? 'Все за период' : moment(DS.filters.date1).format('DD-MM-YYYY') + ' 09:00 – ' + currentMoment.format('DD-MM-YYYY HH:mm')}
				</label>
			</div>
		</div>
		<div className="controller-time p-2 mb-3">
			<div className="mb-3 ml-2 text-left flex">
				<RadioButton inputId="showIntervalQuakes" name="quakesMode" checked={!DS.data.showAllQuakes} onChange={() => DS.setters.setShowAllQuakes(false)} />
				<label htmlFor="showIntervalQuakes" className="ml-2">
					{'Начиная с'}
					<span className={'ml-2' + (!DS.data.showAllQuakes ? ' font-bold' : '')}>
						{(['Оперативный'].includes(DS.filters.period) ? DS.data.loaded : currentMoment).clone().add(quakeMomentOffset - DS.data.maxQuakeMomentOffset, 'hours').format('DD-MM-YYYY HH:mm')}
						{' (-' + ((DS.data.maxQuakeMomentOffset - quakeMomentOffset) > 23 ? (Math.floor((DS.data.maxQuakeMomentOffset - quakeMomentOffset) / 24) + 'д. ') : '' ) + moment('2000-01-01 00:00').add(DS.data.maxQuakeMomentOffset - quakeMomentOffset, 'hours').format('HH:mm)')}
					</span>
				</label>
			</div>
			<Slider value={quakeMomentOffset} min={0} max={DS.data.maxQuakeMomentOffset} step={6} onChange={(e) => setQuakeMomentOffset(e.value)} onMouseDown={e => e.target.focus()} disabled={DS.data.showAllQuakes} />
		</div>
	</Panel>
	
	const removeFromHiddenAlerts = (reg) => {
		DS.setters.setHiddenAlerts(DS.data.hiddenAlerts.filter(e => e.reg !== reg))
	}
	const [showHiddenAlerts, setShowHiddenAlerts] = useState(false)
	const hiddenAlertsFilter = <Panel className="controller mt-3" header={<span className="mr-2">{'Отключения'}</span>} toggleable collapsed={!showHiddenAlerts} onCollapse={() => setShowHiddenAlerts(false)} onExpand={() => setShowHiddenAlerts(true)} >
		<div className="m-3 text-left">
			<div className="flex align-items-center">
				<Checkbox inputId="showDeenergized" onChange={(e) => DS.setters.setShowDeenergized(e.checked)} checked={DS.data.showDeenergized} />
				<label htmlFor="showDeenergized" className="ml-2">{'Отображать на карте'}</label>
			</div>
			<div className="flex align-items-center mt-3">
				<InputNumber className="p-0" inputClassName="w-5em" value={DS.data.alertThreshHi} onChange={e => DS.setters.setAlertThreshHi(e.value)} mode="decimal" useGrouping={false} />
				<label className="ml-3">{'верхний порог'}</label>
			</div>
			<div className="flex align-items-center mt-2">
				<InputNumber className="p-0" inputClassName="w-5em" value={DS.data.alertThreshLo} onChange={e => DS.setters.setAlertThreshLo(e.value)} mode="decimal" useGrouping={false} />
				<label className="ml-3">{'нижний порог'}</label>
			</div>
			{DS.data.hiddenAlerts.length > 0 && <div className="mt-3">
				<label className="">{'Скрытые отключения'}</label>
				{DS.data.hiddenAlerts.map((e, i) => <div key={i} className="flex align-items-center my-2">
					<i className="pi pi-times-circle clickable mr-1" onClick={() => removeFromHiddenAlerts(e.reg)}></i>
					<span>{oktmo2name[code2region[e.reg].oktmo]} ({DS.data.deenergized.filter(el => el.region_code === e.reg).reduce((a, el) => a + +el.population, 0)})</span>
				</div>)}
			</div>}
		</div>
	</Panel>
	
	const weatherFilterOptions = [
		{n: 'Ветер', w: true},
		{n: 'Дождь', w: true},
		{n: 'Обледенение', w: true},
		{n: 'Гроза', w: true},
		{n: 'Жара', w: true},
		{n: 'Град'},
		{n: 'Пожары'},
		{n: 'Наводнение'},
		{n: 'Лавины'},
	]
	const [showWeatherRegFilter, setShowWeatherRegFilter] = useState(false)
	const weatherRegFilter = <Panel className="controller mt-3" header={<span className="mr-2">{'Прогнозы погоды'}</span>} toggleable collapsed={!showWeatherRegFilter} onCollapse={() => setShowWeatherRegFilter(false)} onExpand={() => setShowWeatherRegFilter(true)}>
		<div className="m-3">
			<div className="flex align-items-center">
				<div>{'Прогноз'}</div>
				<Dropdown className="mx-2" value={DS.data.weatherForecastPeriod} options={DS.data.weatherForecastPeriodOptions} onChange={e => DS.setters.setWeatherForecastPeriod(e.value)} />
				<div>{'ч.'}</div>
			</div>
			<div className="flex align-items-center mt-3">
				<Checkbox inputId="showWeatherWarnings" onChange={(e) => DS.setters.setShowWeatherWarnings(e.checked)} checked={DS.data.showWeatherWarnings} />
				<label htmlFor="showWeatherWarnings" className="ml-2">{'Предупреждения'}</label>
			</div>
			<div className="flex align-items-center mt-3">
				<Checkbox inputId="showWeatherDangers" onChange={(e) => DS.setters.setShowWeatherDangers(e.checked)} checked={DS.data.showWeatherDangers} />
				<label htmlFor="showWeatherDangers" className="ml-2">{'Погодная опасность'}</label>
			</div>
			<div className="flex align-items-center mt-3">
				<div>{'Явления'}</div>
				<MultiSelect className="ml-2 text-left" value={DS.data.weatherFilterOptions} options={weatherFilterOptions} optionLabel="n" panelClassName="weather-panel" onChange={e => DS.setters.setWeatherFilterOptions(e.value)} style={{width: '10em'}} />
			</div>
		</div>
	</Panel>
	
	/*
	const [showObjectViewerFilter, setShowObjectViewerFilter] = useState(false)
	const objectViewerFilter = <Panel className="controller mt-3" header={<span className="mr-2">{'Объекты'}</span>} toggleable collapsed={!showObjectViewerFilter} onCollapse={() => setShowObjectViewerFilter(false)} onExpand={() => setShowObjectViewerFilter(true)}>
		<div className="m-3">
			<div className="flex align-items-center mt-3">
				<label className="ml-2">{'Параметр'}</label>
			</div>
		</div>
	</Panel>
	*/
	
	const [showViewportFilter, setShowViewportFilter] = useState(false)
	const [_regs, _setRegs] = useState([])
	const _regions = Object.keys(oktmo2name).map (e => {return {code: e, name: oktmo2name[e]}}).sort((a, b) => a.name.localeCompare(b.name))
	const [objUUIDs, setObjUUIDs] = useState('')
	const viewportSettings = <div className="m-3">
		<div className="flex align-items-center mt-3">
			<Checkbox inputId="showWeatherDangers" onChange={(e) => DS.setters.setUseCustomViewport(e.checked)} checked={DS.data.useCustomViewport} />
			<label htmlFor="showWeatherDangers" className="ml-2">{'Большой экран'}</label>
		</div>
		<Panel className="controller mt-3" header={<span className="mr-2">{'Настройки карты'}</span>} toggleable collapsed={!showViewportFilter} onCollapse={() => setShowViewportFilter(false)} onExpand={() => setShowViewportFilter(true)}>
			<div className="flex align-items-center mt-3">
				<InputNumber className="p-0" inputClassName="w-5em" value={DS.data.customViewportWidth} onChange={e => DS.setters.setCustomViewportWidth(e.value)} mode="decimal" useGrouping={false} />
				<label className="ml-3">{'ширина'}</label>
			</div>
			<div className="flex align-items-center mt-2">
				<InputNumber className="p-0" inputClassName="w-5em" value={DS.data.customViewportHeight} onChange={e => DS.setters.setCustomViewportHeight(e.value)} mode="decimal" useGrouping={false} />
				<label className="ml-3">{'высота'}</label>
			</div>
			<div className="flex align-items-center mt-2">
				<InputNumber className="p-0" inputClassName="w-5em" value={DS.data.customLineScale} onChange={e => DS.setters.setCustomLineScale(e.value)} mode="decimal" maxFractionDigits={1} useGrouping={false} />
				<label className="ml-3">{'коэфф толщины линий'}</label>
			</div>
			<div className="flex align-items-center mt-2">
				<InputNumber className="p-0" inputClassName="w-5em" value={DS.data.customMarkerScale} onChange={e => DS.setters.setCustomMarkerScale(e.value)} mode="decimal" maxFractionDigits={1} useGrouping={false} />
				<label className="ml-3">{'коэфф маркеров'}</label>
			</div>
		</Panel>
		<div className="flex align-items-center mt-3">
			<div>{'Границы'}</div>
			<MultiSelect className="ml-2" value={DS.data.regionBorders} options={_regions} optionLabel={e => e.name} onChange={e => DS.setters.setRegionBorders(e.value)} style={{width: '16em'}} />
		</div>
		<div className="mt-3 text-left">
			<div>{'UUID объектов'}</div>
			<InputTextarea className="w-full mt-2 text-mono" value={objUUIDs} onChange={(e) => setObjUUIDs(e.target.value)} rows={1} autoResize={true} />
			<Button label="Загрузить" className="p-button-sm p-button-link" onClick={() => DS.loadGeoObjects(objUUIDs)}/>
		</div>
		
	</div>
	
	const toggleMapSettings = () => {
		if (DS.userSettings.showMapSettings) mapSettingsRef.current.collapse()
		else mapSettingsRef.current.expand()
		DS.setters.setShowMapSettings(!DS.userSettings.showMapSettings)
	}
	const mapSettingsRef = useRef()
	
	const toggleObjectViewerSettings = () => {
		if (DS.userSettings.showObjectViewerSettings) objectViewerSettingsRef.current.collapse()
		else objectViewerSettingsRef.current.expand()
		DS.setters.setShowObjectViewerSettings(!DS.userSettings.showObjectViewerSettings)
	}
	const objectViewerSettingsRef = useRef()
	
	return <>
		<div className={'inmap-filter' + (DS.filters.showMap ? '' : ' hidden')}>
			<div className="p-3">
				<Button icon="pi pi-arrow-down-left-and-arrow-up-right-to-center" className="p-2 p-button-outlined semiopaq inmap" onClick={resetMapView}/>
			</div>
			
			<div className="panel-wrapper">
				<Panel ref={mapSettingsRef} className="mx-3 map-settings" toggleable collapsed={!DS.userSettings.showMapSettings}
					header={<div className="flex align-items-center justify-content-between">
						{ DS.userSettings.showMapSettings ? <div className="ml-3">{'Информация'}</div> : <div></div>}
						<Button icon="pi pi-bars" className="p-1 p-link text-primary inmap" onClick={toggleMapSettings}/>
					</div>}>
					<div className="a-panel-content p-3 pt-2">
						{eventsFilter}
						{fireFilter}
						{quakeFilter}
						{DS.userSettings.mapOptions.powerOffThresh && hiddenAlertsFilter}
						{DS.userSettings.mapOptions.weatherReg && weatherRegFilter}
						{weatherFilter}
					</div>
				</Panel>
			</div>

			{DS.userSettings.mapOptions.objectViewer && <div className="panel-wrapper">
				<Panel ref={objectViewerSettingsRef} className={'mx-3 mt-3 map-settings'} toggleable collapsed={!DS.userSettings.showObjectViewerSettings}
					header={<div className="flex align-items-center justify-content-between">
						{ DS.userSettings.showObjectViewerSettings ? <div className="ml-3">{'Объекты и печать'}</div> : <div></div>}
						<Button icon="pi pi-cog" className="p-1 p-link text-primary inmap" onClick={toggleObjectViewerSettings}/>
					</div>}>
					<div className="a-panel-content p-3 pt-2">
						{viewportSettings}
					</div>
				</Panel>
			</div>}
		</div>
	</>
	
})

export default MapFilters
